import { clientGetWrapper, clientPostWrapper } from "../api/Api";
import { GET_ALL_LCW_USERS, GET_LCW_FORM_PDF_URL, UPDATE_LCW_USER_REVIEW_STATE, SEARCH_LCW_USER } from "../common/constants/routes";


export const getAllLCWUsers = (page, limit) => {
    return clientGetWrapper(GET_ALL_LCW_USERS, {
        page,
        limit
    });
}


export const updateLCWUserReviewState = (payload) => {
    return clientPostWrapper(UPDATE_LCW_USER_REVIEW_STATE, payload);
}

export const getLCWKvkkFormUrl = () => {
    return clientPostWrapper(GET_LCW_FORM_PDF_URL);

}
export const searchLCWUser = (payload) => {
    return clientPostWrapper(SEARCH_LCW_USER, payload);
}



